import { BaseService } from "./BaseService";
import { SnackBarModule } from "../modules/SnackBarModule";

export const AnalisarFeriasCivilService = {
  async getById(id) {
    const response = await BaseService.fetchResponseFromAPIGet(`civil/analise/ferias/${id}`);
    if (response.error) {
      SnackBarModule("Houve um erro ao consultar as informações deste item", "error");
    }
    return response.content;
  },

  async aprovarFerias(id) {
    const response = await BaseService.fetchResponseFromAPIPost(
      `civil/analiseferias/aprovar/${id}`,
    );
    if (response.error) {
      SnackBarModule(response.message, "error");
      return false;
    }
    SnackBarModule("Aprovado com sucesso.", "success");
    return true;
  },

  async aprovarFeriasLote(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      `civil/analiseferias/aprovaremlote`,
      postData);
    if (response.error) {
      SnackBarModule(response.message, "error");
      return false;
    }
    SnackBarModule("Férias aprovadas com sucesso", "success");
    return true;
  },

  async recusarFerias(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      `civil/analise_recusa`,
      postData,
    );
    if (response.error) {
      SnackBarModule(await response.message.message, "error");
      return false;
    }
    SnackBarModule("Recusado com sucesso.", "success");
    return true;
  },

  async recusarFeriasLote(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      `civil/analise_recusa/emlote`,
      postData,
    );
    if (response.error) {
      SnackBarModule(await response.message.message, "error");
      return false;
    }
    SnackBarModule("Recusado com sucesso.", "success");
    return true;
  },
}